export default class Query {
  #name;
  #aggregateName;
  #lsParams;
  #lpParams;

  constructor(name, aggregateName) {
    this.#name = name;
    this.#aggregateName = aggregateName;
    this.#lsParams = [];
    this.#lpParams = [];
  }

  setName(name) {
    this.#name = name;
  }

  getName() {
    return this.#name;
  }

  setAggregateName(name) {
    this.#aggregateName = name;
  }

  getAggregateName() {
    return this.#aggregateName;
  }

  getLSParams() {
    return this.#lsParams;
  }

  addLSParam(param) {
    this.#lsParams.push(param);
  }

  addLSList(list) {
    this.#lsParams = [...this.#lsParams, ...list];
  }

  getLPParams() {
    return this.#lpParams;
  }

  addLPParam(param) {
    this.#lpParams.push(param);
  }

  addLPList(list) {
    this.#lpParams = [...this.#lpParams, ...list];
  }

  getAllParams() {
    return [...this.#lsParams, ...this.#lpParams];
  }
}
